// extracted by mini-css-extract-plugin
export default {"container":"HVPermission_module-OUD764SQ_container__pDo5U"};